export default __webpack_public_path__ + "static/media/AssassinCreed.37cd793b.jpg";